/**
    @desc On mouseleave event for all shapes in a Viz.
    @param {Object} *d* The data object being interacted with.
    @param {Number} *i* The index of the data object being interacted with.
    @private
*/
export default function (d, i) {
  var _this = this;

  setTimeout(function () {
    if (_this._shapeConfig.hoverOpacity !== 1 && _this._hover ? _this._hover(d, i) : true) {
      _this.hover(false);
    }

    var tooltipData = _this._tooltipClass.data();

    if (tooltipData.length && _this._tooltip(d, i)) {
      var tooltipDatum = tooltipData[0];

      while (tooltipDatum.__d3plus__ && tooltipDatum.data) {
        tooltipDatum = tooltipDatum.data;
      }

      if (_this._id(tooltipDatum) === _this._id(d)) _this._tooltipClass.data([]).render();
    }
  }, 50);

  this._select.style("cursor", "auto");
}